import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

interface StatsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  t: {
    stats: string;
    gamesPlayed: string;
    winRate: string;
    bestTime: string;
    hintsUsed: string;
  };
}

export function StatsModal({ open, onOpenChange, t }: StatsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.stats}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-slate-100 dark:bg-slate-800 rounded-lg">
              <div className="text-sm text-slate-500">{t.gamesPlayed}</div>
              <div className="text-2xl font-bold">0</div>
            </div>
            <div className="p-4 bg-slate-100 dark:bg-slate-800 rounded-lg">
              <div className="text-sm text-slate-500">{t.winRate}</div>
              <div className="text-2xl font-bold">0%</div>
            </div>
            <div className="p-4 bg-slate-100 dark:bg-slate-800 rounded-lg">
              <div className="text-sm text-slate-500">{t.bestTime}</div>
              <div className="text-2xl font-bold">--:--</div>
            </div>
            <div className="p-4 bg-slate-100 dark:bg-slate-800 rounded-lg">
              <div className="text-sm text-slate-500">{t.hintsUsed}</div>
              <div className="text-2xl font-bold">0</div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
